import config from '@config/index';

export const getDirectionsUrl = (coordinates: string): string =>
  `https://www.google.com/maps/dir/?api=1&destination=${coordinates}`;

type GoogleStaticMapType = 'hybrid' | 'roadmap' | 'satellite' | 'terrain';
export const getStaticMapImage = (
  coordinates: string,
  size: string,
  {
    apiKey = config.env.GOOGLE_API_KEY,
    mapIcon,
    mapType = 'roadmap',
    zoom = 16,
  }: {
    apiKey?: string;
    mapIcon?: string;
    mapType?: GoogleStaticMapType;
    zoom?: number;
  } = {}
): string =>
  `https://maps.googleapis.com/maps/api/staticmap?zoom=${zoom}&size=${size}&maptype=${mapType}&markers=color:0x1a892e${
    mapIcon ? `|icon:${mapIcon}` : ''
  }|${coordinates}&key=${apiKey}`;
